import { render, staticRenderFns } from "./DeepSignTemplateSettings.vue?vue&type=template&id=cf5177f8&scoped=true"
import script from "./DeepSignTemplateSettings.vue?vue&type=script&lang=js"
export * from "./DeepSignTemplateSettings.vue?vue&type=script&lang=js"
import style0 from "./DeepSignTemplateSettings.vue?vue&type=style&index=0&id=cf5177f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5177f8",
  null
  
)

export default component.exports